import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { manifestoData } from '../mock';

export const Manifesto = () => {
  const containerRef = useRef(null);
  const isInView = useInView(containerRef, { once: true, margin: '-100px' });

  return (
    <section ref={containerRef} className="py-32 bg-farm-dark relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, #C8A54B 1px, transparent 0)',
          backgroundSize: '50px 50px'
        }} />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl md:text-6xl font-serif font-bold text-farm-cream mb-6">
            Our <span className="text-farm-gold">Manifesto</span>
          </h2>
          <p className="text-xl text-farm-cream/70 max-w-2xl mx-auto">
            The principles that guide everything we do
          </p>
        </motion.div>

        <div className="space-y-32">
          {manifestoData.map((item, index) => (
            <motion.div
              key={item.number}
              initial={{ opacity: 0, y: 50 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className="grid md:grid-cols-2 gap-12 items-center"
            >
              <div className={`${index % 2 === 1 ? 'md:order-2' : ''}`}>
                <motion.div
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={isInView ? { scale: 1, opacity: 1 } : {}}
                  transition={{ duration: 0.6, delay: index * 0.2 + 0.2 }}
                  className="relative"
                >
                  <div className="text-[200px] font-serif font-bold text-farm-gold/10 leading-none">
                    {item.number}
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-8xl font-serif font-bold text-farm-gold">
                      {item.number}
                    </div>
                  </div>
                </motion.div>
              </div>

              <div className={`${index % 2 === 1 ? 'md:order-1' : ''}`}>
                <motion.h3
                  initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
                  animate={isInView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.6, delay: index * 0.2 + 0.3 }}
                  className="text-4xl md:text-5xl font-serif font-bold text-farm-cream mb-6"
                >
                  {item.title}
                </motion.h3>
                <motion.p
                  initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
                  animate={isInView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.6, delay: index * 0.2 + 0.4 }}
                  className="text-xl text-farm-cream/70 leading-relaxed"
                >
                  {item.content}
                </motion.p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};